import useBuildDataAndTree from "./useBuildDataAndTree";
import useDeleteSourceOccurence from "./useDeleteSourceOccurence";
import useGetMappingByControl from "./useGetMappingByControl";
import useSetActualizeDataFromDataGrid from "./useSetActualizeDataFromDataGrid";
import useReplaceOptionValue from "./useReplaceOptionValue.js";
import uuid from "react-native-uuid";

const useHandleOnDrop = () => {
  const buildDataAndTree = useBuildDataAndTree();
  const deleteSourceOccurence = useDeleteSourceOccurence();
  const setActualizeDataFromDataGrid = useSetActualizeDataFromDataGrid();
  const getMappingByControl = useGetMappingByControl();
  const replaceOptionValue = useReplaceOptionValue()

  const searchTexBoxTemplate =
   {  id: 0,
      order: 0,
      type: "TextBox",
      properties: { 
        name: {value: "TextBox",  control:"TextBox"}, 
        text: {value: "",  control:"TextBox"},
        actions: {value: "",  control:"TextBox"},
        readOnly: {value: false ,  control:"CheckBox"},
        placeholder: {value: "" ,  control:"TextBox"},
        toolTip: {value: true ,  control:"CheckBox"}, 
        toolTipText: {value: "" ,  control:"TextBox"},
        maxLength: {value: 200 ,  control:"TextBox"},
        type: {value: "String",  
          control:"ListBox",
          values:[
            {id: "0",  item:"String",  value:"String"},
            {id: "1",  item:"Integer",  value:"Integer"},
            {id: "2",  item:"Decimal",  value:"Decimal"},
          ]
        },
        field: {value: "TextBox" ,  control:"TextBox"},
        masks: {value: "" ,  control:"TextBox", maskValue:""},
        validations: {
          value: "",  
          control:"ListBoxCheckBox",
          selectedValues:[],
          values:[
            {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur"]}},
            {id: "2",  item:"NUMBER",  value:{id:"2",  type:"NUMBER",events:["onChange", "onkeyPress"]}},
            {id: "3",  item:"EMAIL",  value:{id:"3",  type:"EMAIL",events:["onBlur"]}},
            {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}},
            {id: "5",  item:"NOSPACE",  value:{id:"5",  type:"NOSPACE",events:["onkeyPress"]}},
            {id: "6",  item:"NOSPECIALCHAR",  value:{id:"6",  type:"NOSPECIALCHAR",events:["onkeyPress"]}},
            {id: "7",  item:"PATTERN",  value:{id:"7",  type:"PATTERN",events:["onBlur"]}}
          ]
        },
        operators: {
          value: "",  
          control:"ListBoxCheckBox",
          selectedValues:[],
          values:[
            {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
            {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
            {id: "3",  item:"greater",  value:{id:"3",  type:"greater"}},
            {id: "4",  item:"greater & equal",  value:{id:"4",  type:"greater & equal"}},
            {id: "5",  item:"lower",  value:{id:"5",  type:"lower"}},
            {id: "6",  item:"lower & equal",  value:{id:"6",  type:"lower & equal"}},
            {id: "7",  item:"contains",  value:{id:"7",  type:"contains"}},
            {id: "8",  item:"starts with",  value:{id:"8",  type:"starts with"}},
            {id: "9",  item:"ends with",  value:{id:"9",  type:"ends with"}}
          ]
        },
        prefix: {value: "" ,  control:"TextBox"},
        suffix: {value: "" ,  control:"TextBox"},
        wholeNumberLength: {value: 10 ,  control:"TextBox"},
        decimalSize: {value: 2 ,  control:"TextBox"},
        decimalSeparator: {value: "" ,  control:"TextBox"},
        groupSize: {value: 3 ,  control:"TextBox"},
        groupSeparator: {value: "" ,  control:"TextBox"},
        index: {value: false ,  control:"CheckBox"}, 
      },
      styles:{
        fontSize: {value:"14px"},
        fontFamily: {value:"Arial"},
        color: {value:"#212121"},
        width: {value:"100px", hide:true},
        height: {value:"25px", hide:true},
        display: {value:"flex", hide:true},
        top: {value: undefined, hide:true},
        left: {value:undefined, hide:true},
        visibility: {value:"visible"},
        borderLeft: {value:"1px solid #cccccc"},
        borderTop: {value:"1px solid #cccccc"},
        borderTopLeftRadius: {value:"2px"},
        borderTopRightRadius: {value:"2px"},
        borderRight: {value:"1px solid #cccccc"},
        borderBottom: {value:"1px solid #cccccc"},
        borderBottomLeftRadius: {value:"2px"},
        borderBottomRightRadius: {value:"2px"},
        background: {value:"white"},
        boxSizing: {value:"border-box", hide:true},
        textAlign: {value:"left"},
      },
  }
  const replacesType = ["AutoComplete", "HyperText", "Attachment", "ListBox"]

  const handleOnDrop = (updatedFormData, currentParentIds, template, schema) => {
    
    //var currentParentId = currentParentIds[0];
    var current = template
    var id = updatedFormData.lists.currentMaxId
    
    if (template.id == 0) {
      id = id + 1;
      var order = updatedFormData.metaData.length + 1;
      //const name = template.properties.name.value
      template.id = id;
      template.order = order;
      template["globalId"] = uuid.v4()
      template["parentId"] = currentParentIds.id;
      template["parentGlobalId"] = currentParentIds.globalId;
      var rowDetail = undefined
      if (template.type != "Row")
        template.properties.name.value = template.type + id; //name + id;
      else {
        rowDetail = {gridId:schema.gridSettingsId, 
          settingsColIds:JSON.parse(JSON.stringify(template)).metaData.map(item => item.globalId)}
      }
      if (template.metaData) {
        template.metaData.map(
          (item) => {
              id = id + 1;
              item.id = id;
              if (template.type != "Row")
                item.properties.name.value = item.type + id; //item.properties.name.value + id;
              
              item["globalId"] = uuid.v4()
              item["parentId"] = [template.id, ...currentParentIds.id];
              item["parentGlobalId"] = [template.globalId, ...currentParentIds.globalId] ;
              item["left"] = {value:template.left.value};
              item["top"] = {value:template.top.value};
    
              item.order = template.metaData.length + 1; //a revoir mal calcule
                            
          }
        );
        if (template.type == "Row") {
          rowDetail["newColIds"] = template.metaData.map(item => item.globalId)
          template.metaData.map(
            (item) => {
              replaceOptionValue(updatedFormData.actions.option, rowDetail, item)  
            }
          );
        }
      }
      
      current = template
      
      if (schema && schema.type == "DataGrid"){
        const value = handleOnDropDataGrid(template, schema, currentParentIds, id)
        id = value[0]
        current = value[1]
      }
      
      updatedFormData.lists.currentMaxId = id;
    } else {
      
      if (schema && schema.type == "DataGrid"){
        const value =  handleOnDropDataGrid(template, schema, currentParentIds, id)
        updatedFormData.lists.currentMaxId = value[0]
        current = value[1]
        ;
      }
      deleteSourceOccurence(updatedFormData, [template.id] )
    }

    
    
    
    addNewOccurence (updatedFormData,currentParentIds.id[0] , template, schema, updatedFormData); 
    
    updatedFormData.currentTool = [current];
   

    buildDataAndTree(updatedFormData, template.type != "Row")
    
   
    /*
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
    */
    
  };

  const handleOnDropDataGrid = (template, schema, currentParentIds, id) => {
      
      id = id + 1
      var header = JSON.parse(JSON.stringify(template))
      header.id = id
      header.properties.name.value = header.type + id; //name + id;
      header["parentId"] = currentParentIds.id;
      header["parentGlobalId"] = currentParentIds.globalId;
      header["globalId"] = uuid.v4()
      template = header
      var row = JSON.parse(JSON.stringify(template))
      var filter =  JSON.parse(JSON.stringify(template))
      if (replacesType.includes(template.type)) {
        filter = JSON.parse(JSON.stringify(searchTexBoxTemplate))
        filter.styles.height =  {value: template.styles.height.value}
        filter.styles.width =  {value:template.styles.width.value}
      }
      row["headerId"] = id
      filter["headerId"] = id
      id = id + 1
      row.id = id;
      row.properties.name.value = row.type + id; //name + id;
      row["globalId"] = uuid.v4()
      row["parentId"] = currentParentIds.id;
      row["parentGlobalId"] = currentParentIds.globalId;
      

      id = id + 1
      filter.id = id;
      filter.properties.name.value = filter.type + id; //name + id;
      
      filter["globalId"] = uuid.v4()
      filter["parentId"] = currentParentIds.id;
      filter["parentGlobalId"] = currentParentIds.globalId;

      schema["header"] = header
      schema["rows"] = row
      schema["filter"] = filter
      return [id, header]
  };
 /*
  const setActualizeData = (updatedFormData, dataGridId, nRows) => { 
    if (!updatedFormData.metaData) return;
    updatedFormData.metaData.map(control =>{
      
      if (control.type == "ListBox" || control.type == "AutoComplete" || control.type == "DataGrid") {
        
        if (control.properties.data.option) {
          const currentMapping = getMappingByControl(control)
         
          if (currentMapping && currentMapping.value.includes(dataGridId) ) {
            control.properties.actualize.value = control.properties.actualize.value + 1
            control.properties.size.value = nRows
          }
        }
      }

      setActualizeData(control, dataGridId, nRows)
    })
    
  }*/

  const addNewOccurence = (containers,containerId, template, schema, updatedFormData) => {
    if (!containers.metaData) return;
    containers.metaData.map(container => {
        if (container.id == containerId){
          if(schema && schema.type == "DataGrid") {
            container.metaData.filter(item => item.type == "Header")
              .map(item => {
                
                schema.header.parentId = [item.id, ...schema.header.parentId]
                schema.header.parentGlobalId = [item.globalId, ...schema.header.parentGlobalId]
                item.metaData.push(schema.header)
              }
            );
            container.metaData.filter(item => item.type == "Filter")
              .map(item => {
                
                schema.filter.parentId = [item.id, ...schema.filter.parentId]
                schema.filter.parentGlobalId = [item.globalId, ...schema.filter.parentGlobalId]
                item.metaData.push(schema.filter)
              }
            );
            container.metaData.filter(item => item.type == "Rows")
              .map(item => {
                
                schema.rows.parentId = [item.id, ...schema.rows.parentId]
                schema.rows.parentGlobalId = [item.globalId, ...schema.rows.parentGlobalId]
                item.metaData.push(schema.rows)
              }
            );
          } else if(schema && schema.type == "Row") {
            let n = container.metaData.length
            
            container.metaData = [...container.metaData.slice(0,schema.index + 1)
              , template
              ,...container.metaData.slice(schema.index + 1,n) ] ;
             
            container.properties.size.value = container.properties.size.value + 1
            
            setActualizeDataFromDataGrid(updatedFormData, container.globalId, container.properties.size.value)
          }
          
          else container.metaData.push(template);
          
          if (container.selectedValues) {
            if(schema && schema.type == "DataGrid") {         
              container.selectedValues.push(schema.header.id);
            }
            else container.selectedValues.push(template.id);
          }
          return;
        }
        else 
          addNewOccurence(container,containerId, template, schema, updatedFormData);
      }
    )
  };

  return handleOnDrop
};

export default useHandleOnDrop;
